import WalletApi from '../lib/api/Wallet'
import LogonApi from '../lib/api/Logon'

function getToken() {
  const logonApi = new LogonApi()
  return logonApi
    .getToken('?features=wallet')
    .then((response) => response.data)
    .catch(() => null)
}

function getTrackingShopping(walletApi, data) {
  return walletApi
    .trackingVisitShopping(data)
    .then((response) => response.data)
    .catch(() => null)
}

export default async function trackingVisitShopping(data) {
  // get token
  const token = await getToken()
  if (token === null || !token.token) return

  const walletApi = new WalletApi(token)
  // tracking visit shopping
  await getTrackingShopping(walletApi, data)

  return
}
